"use client";

import React from "react";
import { Phone, Loader, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
function SubscribeForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-6 bg-primary-900/50 rounded-lg border border-primary-100/20 max-w-md mx-auto animate-in fade-in zoom-in duration-300">
        <CircleCheck className="size-12 text-secondary mb-4" />
        <p className="text-primary-foreground font-medium text-center">
          {successMessage}
        </p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="w-full max-w-md mx-auto">
      <div className="flex flex-col sm:flex-row gap-3">
        <FormField control={control} name="email" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1">
              <FormControl>
                <Input type="email" placeholder="Enter your email address" className="bg-background text-foreground border-input focus-visible:ring-secondary h-12 px-4" {...field} />
              </FormControl>
              <FormMessage className="text-secondary-100 mt-1 text-left" />
            </FormItem>} />
        <Button type="submit" disabled={isSubmitting} className="h-12 px-8 bg-secondary text-secondary-foreground hover:bg-secondary/90 font-semibold text-base w-full sm:w-auto">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Subscribing...
            </> : "Subscribe"}
        </Button>
      </div>
      {submitError && <p className="text-destructive-foreground bg-destructive/90 p-3 rounded-md mt-4 text-sm text-center">
          {submitError}
        </p>}
    </Form>;
}
export default function SubscribeContactCta() {
  return <section id="subscribe-contact-cta" className="bg-primary text-primary-foreground py-20 md:py-28 px-6 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary-900/20 to-transparent pointer-events-none" />
      
      <div className="container mx-auto max-w-4xl relative z-10 text-center">
        <div className="mb-10 space-y-4">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-primary-foreground">
            Stay Updated on Exterior Care Tips
          </h2>
          <p className="text-primary-100 text-lg md:text-xl max-w-2xl mx-auto">
            Join our newsletter to receive expert advice, seasonal maintenance checklists, and exclusive offers directly to your inbox.
          </p>
        </div>

        <div className="mb-12">
          <FormProvider formId="newsletter-subscribe-cta" sectionName="SubscribeContactCta" defaultValues={{
          email: ""
        }} submitText="Subscribe" successMessage="Thank you for subscribing! You'll hear from us soon.">
            <SubscribeForm />
          </FormProvider>
        </div>

        <div className="pt-8 border-t border-primary-100/20 flex flex-col items-center justify-center gap-4">
          <p className="text-primary-100 text-sm uppercase tracking-wider font-semibold">
            Still have questions after reading?
          </p>
          <p className="text-primary-100 text-sm uppercase tracking-wider font-semibold">
            Need immediate assistance?
          </p>
          <Link to="tel:+15551234567" className="inline-flex flex-col md:flex-row items-center gap-3 text-xl md:text-2xl font-default font-bold text-primary-foreground hover:text-secondary transition-colors group">
            <div className="flex items-center gap-3">
              <span className="bg-primary-900/50 p-3 rounded-lg group-hover:bg-secondary/20 transition-colors">
                <Phone className="size-6 text-secondary" />
              </span>
              Call Now for Free Advice: (240) 899-1278
            </div>
            <span className="text-sm font-normal text-primary-200 md:ml-2">Experts answer in 5 minutes or less</span>
          </Link>
        </div>
      </div>
    </section>;
}